import { AppStore } from "./Stores/AppStore";
import { Urls } from "./Urls";

export function newGuid() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}
	return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
		s4() + '-' + s4() + s4() + s4();
}

export function setCookie(name: string, value: string, days?: number) {
	let expires: string;
	if (days) {
		let date: Date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	else {
		expires = "";
	}
	document.cookie = name + "=" + encodeURI(value) + expires + "; path=/";
}

export function getCookie(name: string) {
	var value = "; " + document.cookie;
	var parts = value.split("; " + name + "=");
	if (parts.length == 2) {
		return parts.pop().split(";").shift();
	}
	else {
		return null;
	}
}

export function getUiLanguage() {
	let cookie = getCookie(".AspNetCore.Culture");
	return cookie ? cookie.split('%7')[0].split('=')[1] : null;
}

export function format(msg: string, ...args: any[]) {
	return msg.replace(/\{(\d+)\}/g, function (match, index) {
		return args[index];
	});
}

interface IObjectForScripting {
	DebugLog(msg: string): void;
}

export function DebugLog(msg: string) {
	try {
		if (console.log) {
			console.log(msg);
		}

		if (AppStore.context && AppStore.context.sessionDetails.isLogging) {

			if (window.external) {
				let scriptingObject = (<any>window.external) as IObjectForScripting;
				if (scriptingObject.DebugLog)
					scriptingObject.DebugLog(msg);
			}
		}
	}
	catch (ex) {
	}
}

export function stopWatch(start?: number): number {
	if (start) {
		return Math.ceil((performance.now() || Date.now()) - start);
	}
	else {
		return performance.now() || Date.now();
	}
}

export function getDeepLinkReaderUrl(docId: string, language: string, name: string, mimeType: string): string {
	let filename = name + mapMimeTypeToExtension(mimeType);
	let lang = (language == null || language.trim() == "") ? "iv" : language;
	let shareLink: string = Urls.reader + "/" + docId + "/" + encodeURIComponent(lang) + "/" + encodeURIComponent(filename);
	return shareLink;
}

export function mapMimeTypeToExtension(mimeType: string): string {
	let result: string = null;
	switch (mimeType) {
		case "text/html; charset=utf-8":
			result =  ".html";
			break;
		case "text/xml; charset=utf-8":
			result =  ".xml";
			break;
		case "text/css; charset=utf-8":
			result =  ".css";
			break;
		case "application/javascript: charset=utf-8":
		case "text/javascript: charset=utf-8":
			result =  ".js";
			break;
		case "image/gif":
			result =  ".gif";
			break;
		case "image/x-icon":
			result =  ".ico";
			break;
		case "video/mp4":
			result = ".mp4";
			break;
		case "application/pdf":
			result = ".pdf";
			break;
		case "application/epub+zip":
			result = ".epub";
			break;
		case "image/png":
			result = ".png";
			break;
		case "image/jpeg":
			result = ".jpg";
			break;
		case "image/svg+xml":
			result = ".svg";
			break;
		case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
			result = ".docx";
			break;
		case "application/vnd.ms-word.document.macroenabled.12":
			result = ".docm";
			break;
		case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
			result = ".xlsx";
			break;
		case "application/vnd.ms-excel.sheet.macroenabled.12":
			result = ".xlsm";
			break;
		case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
			result = ".pptx";
			break;
		case "application/vnd.ms-powerpoint.presentation.macroenabled.12":
			result = ".pptm";
			break;
		case "application/zip":
			result = ".zip";
			break;
		case "application/json":
			result = ".json";
			break;
		case "application/font-woff":
			result = ".woff";
			break;
		case "application/font-woff2":
			result = ".woff2";
			break;
		case "application/font-sfnt":
			result = ".sfnt";
			break;
		case "application/vnd.ms-fontobject":
			result = ".eot";
			break;
		default:
			if (mimeType !== null && mimeType.lastIndexOf("/") > 0) {
				result = "." + mimeType.substring(mimeType.lastIndexOf("/") + 1);
			} else {
				result = mimeType !== null ? mimeType : "";
			}
	}
	return result;
}

export function getReaderUrl(guid: string, mimeType: string): string {
	let url = Urls.reader;
	return Urls.reader + "/" + guid + mapMimeTypeToExtension(mimeType);
}

export function getDisplayMimetype(mimeType: string) {
	return mimeType === "application/zip" || mimeType == "application/x-zip-compressed" ? "text/html" : mimeType;
}
